import React, { useEffect, useState } from "react";
import { Container, Typography, MenuItem, Tooltip, Modal, InputLabel, FormControl, Grid, Select, TextField, FormControlLabel, Checkbox, Table, TableHead, TableBody, Button, TableContainer, TableCell, TableRow, Paper, Box } from '@mui/material';
import { Add, Delete } from "@mui/icons-material";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useNavigate, useParams } from "react-router-dom";
import base64 from "base64-js";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const AddClass = () => {
  const [canDelete, setCanDelete] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [selectedValue, setSelectedValue] = useState("lightOptionValue");
  const [className, setClassName] = useState("");
  const [sequenceNo, setSequenceNo] = useState("");
  const [classType, setClassType] = useState([]);
  const [teacherData, setTeacherData] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [sectionNameValue, setSectionNameValue] = useState("");
  const [seatCapacityValue, setSeatCapacityValue] = useState("");
  const [inchargeValue, setInchargeValue] = useState("");
  const [sectionDetails, setSectionDetails] = useState([]);
  const [chargeDetails, setChargeDetails] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [initialChargeDetails, setInitialChargeDetails] = useState([]); // Add this line
  let navigate = useNavigate();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  // Define other required states
  // const [classMinAge, setClassMinAge] = useState('');
  //const [classMaxAge, setClassMaxAge] = useState('');
  const [noOf_BrackLeacture, setNoOf_BrackLeacture] = useState("");
  const [noOfBrack, setNoOfBrack] = useState("");
  // const [maxLecture, setMaxLecture] = useState('');
  const [resultTypeId, setresultTypeId] = useState("");
  const [maxLecture, setMaxLectureAllowed] = useState("");
  const [noBreakCheckbox, setNoBreakCheckbox] = useState(false);
  const [breakAfterLectureNo, setBreakAfterLectureNo] = useState("");
  const [classMinAge, setMinAge] = useState("");
  const [classMaxAge, setMaxAge] = useState("");

  const decodeFormId = (encodedFormId) => {
  if (!encodedFormId || typeof encodedFormId !== "string") {
    console.error("encodedFormId is missing or invalid:", encodedFormId);
    return null;
  }
  try {
    const paddedEncodedFormId = encodedFormId.padEnd(Math.ceil(encodedFormId.length / 4) * 4, "=");
    const bytes = base64.toByteArray(paddedEncodedFormId);
    return new TextDecoder().decode(bytes);
  } catch (error) {
    console.error("Error decoding formId:", error);
    return null;
  }
};

const { encodedFormId } = useParams();
const formId = decodeFormId(encodedFormId);

const Authorizer = async () => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: token },
      body: JSON.stringify({ formId }),
    });
    const result = await response.json();
    const data = result[0];
    setCanDelete(data?.uDelete === 1);
  } catch (error) {
    console.error("Authorization check failed:", error);
  }
};

  const handleToggleAll = (event) => {
    const checked = event.target.checked;
    const updatedChargeDetails = chargeDetails.map((item) => ({
      ...item,
      checked,
    }));
    setChargeDetails(updatedChargeDetails);
    setSelectAllChecked(checked); // Update the selectAllChecked state
  };

  const fetchClassType = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CreateClass/ddlClassType`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching class: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        return; // Exit the function if the record is not found
      }
      setClassType(data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchTeacher = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CreateClass/ddlTeacher`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching religion data: ${response.status}`);
      }

      const data = await response.json();

      if (data.data === null && data.msg === "Record Not Found") {
        return; // Exit the function if the record is not found
      }

      setTeacherData(data);
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error")

    }
  };

  const fetchSection = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CreateClass/ddlSection`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching religion data: ${response.status}`);
      }

      const data = await response.json();

      if (data.data === null && data.msg === "Record Not Found") {
        return; // Exit the function if the record is not found
      }

      setSectionData(data);
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const fetchddlcharge = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CreateClass/ddlChargeDetails`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching class: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        return; // Exit the function if the record is not found
      }
      setChargeDetails(data);
      setInitialChargeDetails(data); // Store the initial data
    } catch (error) {
      console.error(error);
    }
  };

  const handleAddSectionDetails = () => {
    // Find the selected section object using its ID
    const selectedSection = sectionData.find(
      (section) => section.sectionId === sectionNameValue
    );

    // Create a new section object with the selected section's name and other details
    const newSection = {
      sectionId: sectionNameValue,
      sectionName: selectedSection ? selectedSection.sectionName : "",
      seatCapacity: seatCapacityValue,
      incharge:
        teacherData.find((teacher) => teacher.employeeId === inchargeValue)
          ?.employeeName || "",
      inchargeId: inchargeValue,
    };

    // Add the new section to the sectionDetails state
    setSectionDetails([...sectionDetails, newSection]);

    // Clear section details fields
    setSectionNameValue("");
    setSeatCapacityValue("");
    setInchargeValue("");
  };

  const handleDeleteSection = (index) => {
    const updatedSectionDetails = [...sectionDetails];
    updatedSectionDetails.splice(index, 1);
    setSectionDetails(updatedSectionDetails);
  };

  const handleReset = () => {
    // Reset all state variables to their initial values
    setSelectedValue("lightOptionValue");
    setClassName("");
    setSequenceNo("");
    setSectionNameValue("");
    setSeatCapacityValue("");
    setInchargeValue("");
    setSectionDetails([]);
    setSelectAllChecked(false);
    setNoOf_BrackLeacture("");
    setNoOfBrack("");
    setMaxLectureAllowed("");
    setNoBreakCheckbox(false);
    setBreakAfterLectureNo("");
    setMinAge("");
    setMaxAge("");
    setresultTypeId("");
    setChargeDetails(initialChargeDetails.map(charge => ({ ...charge, checked: false, charge: "" })));
  };


  const handleSave = async () => {
    try {
      const Url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${Url}/CreateClass`;
      const token = sessionStorage.getItem("token");

      // Prepare sections data array
      const sectionsData = sectionDetails.map((section) => ({
        sectionId: section.sectionId,
        seactCapacity: section.seatCapacity,
        teacherId: section.inchargeId,
      }));

      // Prepare class charge data array
      const classChargeData = chargeDetails
        .filter((charge) => charge.checked)
        .map((charge) => ({
          charge: charge.charge,
          chargeId: charge.chargeId,
        }));

      // Prepare request body
      const requestBody = {
        className,
        sequenceNo: sequenceNo || 0,
        classTypeId: selectedValue,
        classMinAge,
        classMaxAge,
        noOf_BrackLeacture: breakAfterLectureNo || 0,
        no_OfBrack: 1,
        maxLecture,
        resultTypeId,
        sectionsData,
        classChargeData,
      };

      // Make API call to post data
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        // alert(`Error posting data: ${response.status}`);
        setSnackbarMessage(`Error posting data: ${response.status}`);
        setOpenSnackbar(true);
        setSnackbarSeverity("error")
      } else {
        // Handle success response
        setShowSuccessModal(true);

        // Clear form fields
        setSelectedValue("lightOptionValue");
        setClassName("");
        setSequenceNo("");
        setSectionNameValue("");
        setSeatCapacityValue("");
        setInchargeValue("");
        setSectionDetails([]);
        setSelectAllChecked(false);
        setNoOf_BrackLeacture("");
        setNoOfBrack("");
        setMaxLectureAllowed("");
        setNoBreakCheckbox(false);
        setBreakAfterLectureNo("");
        setMinAge("");
        setMaxAge("");
        setresultTypeId("");

        // Reset chargeDetails to initial data
        setChargeDetails(initialChargeDetails.map(charge => ({ ...charge, charge: "" }))); // Reset to initial data and clear charge field
      }
    } catch (error) {
      // alert(error);
      setSnackbarMessage(error);
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  useEffect(() => {
    fetchClassType();
    fetchTeacher();
    fetchSection();
    fetchddlcharge();
    Authorizer();
  }, []);

  const handleMaxLectureChange = (event) => {
    setMaxLectureAllowed(event.target.value);
  };

  // Handle change for No break checkbox
  const handleNoBreakCheckboxChange = (event) => {
    setNoBreakCheckbox(event.target.checked);
  };

  // Handle change for Break after Lecture No.
  const handleBreakAfterLectureChange = (event) => {
    setBreakAfterLectureNo(event.target.value);
  };

  // Handle change for Min Age
  const handleMinAgeChange = (event) => {
    setMinAge(event.target.value);
  };

  // Handle change for Max Age
  const handleMaxAgeChange = (event) => {
    setMaxAge(event.target.value);
  };

  // Handle change for No of Break Lecture
  const handleNoOfBrackLectureChange = (event) => {
    setNoOf_BrackLeacture(event.target.value);
  };

  const handleresultTypeIdChange = (event) => {
    setresultTypeId(event.target.value);
  };

  const handleSelectValueChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleIndividualCheckboxChange = (index) => {
    const updatedChargeDetails = [...chargeDetails];
    updatedChargeDetails[index].checked = !updatedChargeDetails[index].checked;

    setChargeDetails(updatedChargeDetails);

    // Update selectAllChecked state
    const allChecked = updatedChargeDetails.every((item) => item.checked);
    setSelectAllChecked(allChecked);
  };

  return (
    <div>
      <Container>
        <Box
          sx={{
            backgroundColor: '#0B1F40', // dark navy blue
            padding: '12px 24px',
            boxShadow: 3,
            borderRadius: '4px 4px 0 0',
            margin: '2px auto',
            width: "100%",
          }}
        >
          <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
            Add Class
          </Typography> </Box>
        <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>
          <Grid container spacing={3} mt={1}>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <InputLabel htmlFor="classType">Class Type</InputLabel>
                <Select
                  value={selectedValue}
                  onChange={handleSelectValueChange}
                  label="Class Type"
                  id="classType"
                >
                  {classType.map((item) => (
                    <MenuItem key={item.classTypeId} value={item.classTypeId}>
                      {item.classType}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                fullWidth
                label="Class Name"
                value={className}
                onChange={(e) => setClassName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                fullWidth
                label="Sequence Number"
                value={sequenceNo}
                onChange={(e) => setSequenceNo(e.target.value)}
              />
            </Grid>
          </Grid>

          <Grid container spacing={3} mt={1}>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                fullWidth
                label="Max Lecture Allowed"
                value={maxLecture}
                onChange={handleMaxLectureChange}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={noBreakCheckbox}
                    onChange={handleNoBreakCheckboxChange}
                  />
                }
                label="No Break"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                fullWidth
                label="Break After Lecture No."
                value={breakAfterLectureNo}
                onChange={handleBreakAfterLectureChange}
                disabled={noBreakCheckbox} // Disable the input when no break checkbox is checked
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                fullWidth
                label="Min Age"
                value={classMinAge}
                onChange={handleMinAgeChange}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                fullWidth
                label="Max Age"
                value={classMaxAge}
                onChange={handleMaxAgeChange}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <InputLabel htmlFor="resultTypeId">Result Type</InputLabel>
                <Select
                  value={resultTypeId}
                  onChange={handleresultTypeIdChange}
                  label="Result Type"
                  id="resultTypeId"
                >
                  <MenuItem value="">--Select--</MenuItem>
                  <MenuItem value="1">Grading Wise</MenuItem>
                  <MenuItem value="2">Division Wise</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Paper>
        <Box mt={3}>
          <Box
            sx={{
              backgroundColor: '#0B1F40', // dark navy blue
              padding: '12px 24px',
              boxShadow: 3,
              borderRadius: '4px 4px 0 0',
              margin: '1px auto',
            }}
          >
            <Typography variant="h5" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Add Section Details
            </Typography> </Box>


        </Box>
        <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>

          <Grid container spacing={3} mt={1}>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel htmlFor="sectionName">Section Name</InputLabel>
                <Select
                  value={sectionNameValue}
                  onChange={(e) => setSectionNameValue(e.target.value)}
                  label="Section Name"
                  id="sectionName"
                >
                  {sectionData.map((section) => (
                    <MenuItem key={section.sectionId} value={section.sectionId}>
                      {section.sectionName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Seat Capacity"
                value={seatCapacityValue}
                onChange={(e) => setSeatCapacityValue(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel htmlFor="incharge">Incharge</InputLabel>
                <Select
                  value={inchargeValue}
                  onChange={(e) => setInchargeValue(e.target.value)}
                  label="Incharge"
                  id="incharge"
                >
                  {teacherData.map((teacher) => (
                    <MenuItem key={teacher.employeeId} value={teacher.employeeId}>
                      {teacher.employeeName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                onClick={handleAddSectionDetails}
              >
                Add Section
              </Button>
            </Grid>
          </Grid>
        </Paper>
        <Box mt={3}>
          <Box
            sx={{
              backgroundColor: '#0B1F40', // dark navy blue
              padding: '12px 24px',
              boxShadow: 3,
              borderRadius: '4px 4px 0 0',
              margin: '2px auto',
            }}
          >
            <Typography variant="h5" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Section Details List
            </Typography> </Box>


          {sectionDetails.length === 0 ? (
            <Typography>No sections added.</Typography>
          ) : (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Section Name</TableCell>
                    <TableCell>Seat Capacity</TableCell>
                    <TableCell>Incharge</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sectionDetails.map((section, index) => (
                    <TableRow key={index}>
                      <TableCell>{section.sectionName}</TableCell>
                      <TableCell>{section.seatCapacity}</TableCell>
                      <TableCell>{section.incharge}</TableCell>
                      <TableCell>
                        <Tooltip title={!canDelete && "You are not Authorized to Delete"} arrow>
  <span>
    <Button
      variant="contained"
      color="secondary"
      startIcon={<Delete />}
      onClick={() => handleDeleteSection(index)}
      disabled={!canDelete}
    >
      Delete
    </Button>
  </span>
</Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}

        </Box>
        <Box mt={3}>
          <Box
            sx={{
              backgroundColor: '#0B1F40', // dark navy blue
              padding: '12px 24px',
              boxShadow: 3,
              borderRadius: '4px 4px 0 0',
              margin: '2px auto',
            }}
          >
            <Typography variant="h5" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Class Charge Details
            </Typography> </Box>

          {chargeDetails.length === 0 ? (
            <Typography>No charge details available.</Typography>
          ) : (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={selectAllChecked}
                            onChange={handleToggleAll}
                          />
                        }
                        label="Select All"
                      />
                    </TableCell>
                    <TableCell>Charge Name</TableCell>
                    <TableCell>Charge Type</TableCell>
                    <TableCell>Charge</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {chargeDetails.map((charge, index) => (
                    <TableRow key={charge.chargeId}>
                      <TableCell>
                        <Checkbox
                          checked={charge.checked || false}
                          onChange={() => handleIndividualCheckboxChange(index)}
                        />
                      </TableCell>
                      <TableCell>{charge.chargeName}</TableCell>
                      <TableCell>{charge.chargeType}</TableCell>
                      <TableCell>
                        <TextField
                          id={`charge-${index}`}
                          label="Charge"
                          variant="outlined"
                          type="number"
                          fullWidth
                          value={charge.charge}
                          onChange={(e) => {
                            let value = e.target.value;

                            // Ensure only non-negative numbers are accepted
                            if (Number(value) < 0) {
                              value = "0"; // or you can use "" to clear it instead
                            }

                            const updatedChargeDetails = [...chargeDetails];
                            updatedChargeDetails[index].charge = value;

                            // Auto-check if value is greater than 0
                            updatedChargeDetails[index].checked = Number(value) > 0;

                            // Update selectAllChecked based on all checked items
                            const allChecked = updatedChargeDetails.every((item) => item.checked);
                            setSelectAllChecked(allChecked);

                            setChargeDetails(updatedChargeDetails);
                          }}

                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>

        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          style={{
            marginTop: '7px',
            width: "100px",
            height: "50px",
            padding: "10px 0",
            fontWeight: 'bold',
            marginRight: '10px' // Add margin to the right of the first button
          }}
        >
          Save
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleReset} // Assuming you have a handleReset function
          style={{
            marginTop: '7px',
            width: "100px",
            height: "50px",
            padding: "10px 0",
            fontWeight: 'bold'
          }}
        >
          Reset
        </Button>

      </Container>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Class Added ✅
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              The Class has been added successfully.
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1); // go back after closing modal
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>


    </div>
  );
};

export default AddClass;
